import { createContext, ReactNode, useMemo, useReducer } from 'react';

import { subscribeScreens } from '@/components/subscribe/SubscribeScreens/data';
import { useUserState } from '@/hooks/store';

import { ActiveScreen, SubscribeState } from './types';

function activeScreenReducer(state: ActiveScreen, nextScreen: ActiveScreen): ActiveScreen {
	if (typeof window !== 'undefined') {
		window.scrollTo(0, 0);
	}
	return nextScreen;
}

export const SubscribeContext = createContext<SubscribeState>({
	activeScreen: 'account',
	setActiveScreen: () => {},
	activeComponentName: 'AccountScreen',
});

const SubscribeContextProvider = ({ children }: { children: ReactNode }) => {
	const user = useUserState();
	const [activeScreen, setActiveScreen] = useReducer(activeScreenReducer, user ? 'payment' : 'account');

	const value = useMemo(
		() => ({
			activeScreen,
			setActiveScreen,
			activeComponentName: subscribeScreens[activeScreen]?.componentName,
		}),
		[activeScreen],
	);

	return <SubscribeContext.Provider value={value}>{children}</SubscribeContext.Provider>;
};

export default SubscribeContextProvider;
